import { formatDate, formatTime } from "../services/helpers";
import { Col, Row } from "react-bootstrap";
import { marked } from "marked";
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import useMessageAttachments from "../hooks/useMessageAttachments";
import { defineMessages, injectIntl } from "react-intl";
import PropTypes from "prop-types";

export const messages = defineMessages({
    openFile: {
        id: "Avaa tiedosto",
        defaultMessage: 'Avaa tiedosto'
    },
    supportAuthorPrefix: {
        id: "Ropo - Asiakaspalvelija",
        defaultMessage: 'Ropo - Asiakaspalvelija'
    }
});

const MessageContentComment = ({ intl, comment, sameDate, onClickAttachment, attachments }) => {
    const { processAttachmentIds } = useMessageAttachments();
    const lng = intl.formatMessage;

    if (comment.type !== 'attachment' && comment.comment.length === 0) {
        return null
    }

    let authorName = comment.author_name;

    if (authorName === undefined || authorName === null) {
        authorName = '';
    } else {
        authorName = authorName.split(' ')[0];
    }

    const attachmentButtons = (attachmentIds) => {
        if (!Array.isArray(attachmentIds) || attachmentIds.length === 0) {
            return <></>;
        }
        return processAttachmentIds(attachmentIds, attachments).map(({ icon, attachment }) => (
            <button
                key={attachment.id}
                type="button"
                className={'actionlist-button btn btn-tertiary-menu'}
                onClick={() => onClickAttachment(attachment)}
                aria-label={lng(messages.openFile)}
            >
                <FontAwesomeIcon icon={icon} className='me-2 attachment-icon' />
                {attachment.filename}
            </button>
        ))
    }

    return (
        <div key={'comment-' + comment.id}>
            {!sameDate && (
                <p className={'text-muted fs-6 mt-4 mb-2' + (comment.author === 'support' ? ' text-end' : ' text-center')}>
                    {formatDate(comment.sent_date)}
                </p>
            )}

            {comment.is_support && (
                <p className="author-name">
                    {comment.author_name === 'Ropo AI' ? 'Ropo AI' : `${lng(messages.supportAuthorPrefix)} ${authorName}`}
                </p>
            )}

            <Row key={'comment-' + comment.id} className={'mb-2 message ' + (comment.is_support === true ? ' support' : 'customer')} >
                <Col xs={12}>
                    {attachmentButtons(comment.attachment_ids)}
                    {comment.comment && comment.comment.length > 0 && (
                        <p className="mb-2" dangerouslySetInnerHTML={{ __html: marked(comment.comment) }}></p>
                    )}
                    <p className='text-muted fs-6 mb-1'>{formatTime(comment.sent_date)}</p>
                </Col>
            </Row>
        </div>
    )
}

MessageContentComment.propTypes = {
    intl: PropTypes.object,
    attachments: PropTypes.array,
    comment: PropTypes.object,
    sameDate: PropTypes.bool,
    onClickAttachment: PropTypes.func
};

export default injectIntl(MessageContentComment);
